<template>
  <div id="content" class="center-element">
    <p>
      <span class="bold">
        {{ name }}
      </span>
      is a leading provider of advanced analytics technology, specifically aimed
      at website performance improvement. Our technology can provide real-time
      analysis of customer feedback and provide performance alerts and reports
      that immediately lead to revenue and customer satisfaction improvements.
      If you want to put your customer at the center of everything you do, our
      voice of customer application is the most efficient and effective way to
      understand how your customers perceive your products, services and website
      experience. We deliver insights that enable your business to take action
      to increase revenues and deliver higher customer satisfaction ratings.
    </p>
    <p>
      Most businesses who operate a website struggle with the ability to
      identify and prioritize performance improvement actions. Our applications
      unlock the power of customer feedback and transform it into easy to digest
      areas of improvement that can be used to prioritize your site activities.
      <span class="bold">
        {{ name }}
      </span>
      gives you the information and the confidence to know what actions to take
      to improve customer perceptions, willingness to recommend, and website
      conversion.
    </p>
  </div>
</template>

<script>
// @ is an alias to /src

export default {
  name: "ConsoleLanding",
  data() {
    return {
      name: process.env.VUE_APP_FACE
    };
  }
};
</script>
<style>
.buttons div {
  lost-column: 1/1;
}

@media (min-width: 480px) {
  .buttons {
    lost-center: 480px;
  }
  .buttons div {
    lost-column: 1/2;
  }
}
</style>
